import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentLang: 'th',
    translations: {
      th: {
        landing: {
          titleLine1: 'วิเคราะห์',
          titleLine2: 'ธาตุเจ้าเรือน',
          subtitle: 'เพื่อปรับสมดุลสู่สุขภาพที่ดีในแบบคุณ',
          datePlaceholder: 'ระบุวันเกิดของท่าน',
          dateError: 'กรุณาเลือกวันเกิด',
          analyzeButton: 'เริ่มการวิเคราะห์',
          pageTitle: 'ธาตุเจ้าเรือน',
        },
        spinning: {
          analyzing: 'กำลังวิเคราะห์',
          resultButton: 'ดูผลการวิเคราะห์',
          pageTitle: 'ธาตุเจ้าเรือน',
        },
        result: {
          pageTitle: 'ผลการวิเคราะห์',
          headerTitle: 'ผลการวิเคราะห์',
          tabCharacteristics: 'คุณลักษณะธาตุ',
          tabAdvice: 'คำแนะนำ',
          tabRestaurants: 'ร้านอาหารแนะนำ',
        },
        characteristics: {
          cardLabel: 'ธาตุเจ้าเรือนของท่านคือ',
          traits: '“ มีเหตุผล คล่องแคล่ว จิตใจเมตตาอารี ”',
          weaknessTitle: 'จุดอ่อน',
          weaknessSubtitle: 'มักเจ็บป่วยด้วยอาการ',
          seasonTitle: 'ฤดู หรือ สภาพอากาศที่มีโอกาสเจ็บป่วยได้ง่าย',
        },
        advice: {
          foodTitle: 'อาหารที่ควรรับประทาน',
          footer: 'กินเย็น จะได้เย็นทั้งกาย ทั้งใจ รักษาสมดุลพลังธาตุไฟ',
          // Keyed by the FOOD_DETAILS field the row reads
          food_example: 'ตัวอย่างเมนูอาหาร',
          desserts: 'ขนมหวาน',
          drink: 'เครื่องดื่ม',
          fruit: 'ผลไม้',
          vegetable: 'ผัก',
        },
        restaurant: {
          header: 'แนะนำร้านอาหารตามธาตุ',
          region: 'ภูมิภาค',
          province: 'จังหวัด',
          noDataText: 'ไม่พบข้อมูล',
          empty: 'ไม่พบร้านอาหาร',
          addressLabel: 'ที่อยู่ร้าน',
          navigate: 'กดเพื่อนำทาง',
          viewMenu: 'กดเพื่อดูเมนู',
          loadMore: 'โหลดเพิ่มเติม',
          menuHeader: 'เมนูอาหาร',
          noMenu: 'ไม่มีเมนูอาหาร',
          close: 'ปิด',
        },
        // Keyed by the Thai element name the data files use, so the lookup
        // keys inside the views stay untouched when the language changes
        elements: {
          'ธาตุไฟ': 'ธาตุไฟ',
          'ธาตุลม': 'ธาตุลม',
          'ธาตุน้ำ': 'ธาตุน้ำ',
          'ธาตุดิน': 'ธาตุดิน',
        }
      },
      // Placeholder: EN carries the Thai copy until the translations arrive.
      // The keys are already the full set, so swapping in English is a
      // values-only edit to this block.
      en: {
        landing: {
          titleLine1: 'วิเคราะห์',
          titleLine2: 'ธาตุเจ้าเรือน',
          subtitle: 'เพื่อปรับสมดุลสู่สุขภาพที่ดีในแบบคุณ',
          datePlaceholder: 'ระบุวันเกิดของท่าน',
          dateError: 'กรุณาเลือกวันเกิด',
          analyzeButton: 'เริ่มการวิเคราะห์',
          pageTitle: 'ธาตุเจ้าเรือน',
        },
        spinning: {
          analyzing: 'กำลังวิเคราะห์',
          resultButton: 'ดูผลการวิเคราะห์',
          pageTitle: 'ธาตุเจ้าเรือน',
        },
        result: {
          pageTitle: 'ผลการวิเคราะห์',
          headerTitle: 'ผลการวิเคราะห์',
          tabCharacteristics: 'คุณลักษณะธาตุ',
          tabAdvice: 'คำแนะนำ',
          tabRestaurants: 'ร้านอาหารแนะนำ',
        },
        characteristics: {
          cardLabel: 'ธาตุเจ้าเรือนของท่านคือ',
          traits: '“ มีเหตุผล คล่องแคล่ว จิตใจเมตตาอารี ”',
          weaknessTitle: 'จุดอ่อน',
          weaknessSubtitle: 'มักเจ็บป่วยด้วยอาการ',
          seasonTitle: 'ฤดู หรือ สภาพอากาศที่มีโอกาสเจ็บป่วยได้ง่าย',
        },
        advice: {
          foodTitle: 'อาหารที่ควรรับประทาน',
          footer: 'กินเย็น จะได้เย็นทั้งกาย ทั้งใจ รักษาสมดุลพลังธาตุไฟ',
          food_example: 'ตัวอย่างเมนูอาหาร',
          desserts: 'ขนมหวาน',
          drink: 'เครื่องดื่ม',
          fruit: 'ผลไม้',
          vegetable: 'ผัก',
        },
        restaurant: {
          header: 'แนะนำร้านอาหารตามธาตุ',
          region: 'ภูมิภาค',
          province: 'จังหวัด',
          noDataText: 'ไม่พบข้อมูล',
          empty: 'ไม่พบร้านอาหาร',
          addressLabel: 'ที่อยู่ร้าน',
          navigate: 'กดเพื่อนำทาง',
          viewMenu: 'กดเพื่อดูเมนู',
          loadMore: 'โหลดเพิ่มเติม',
          menuHeader: 'เมนูอาหาร',
          noMenu: 'ไม่มีเมนูอาหาร',
          close: 'ปิด',
        },
        elements: {
          'ธาตุไฟ': 'ธาตุไฟ',
          'ธาตุลม': 'ธาตุลม',
          'ธาตุน้ำ': 'ธาตุน้ำ',
          'ธาตุดิน': 'ธาตุดิน',
        }
      }
    }
  },
  getters: {
    currentLang: state => state.currentLang,
    translateFunction: state => (page, key) => {
      const dict = state.translations[state.currentLang] || {}
      const group = dict[page] || {}
      return group[key] || key
    },
    translations: state => state.translations[state.currentLang]
  },
  mutations: {
    SET_LANGUAGE(state, lang) {
      state.currentLang = lang
    }
  },
  actions: {
    toggleLanguage({ commit, state }) {
      const newLang = state.currentLang === 'th' ? 'en' : 'th'
      commit('SET_LANGUAGE', newLang)
    },
    setLanguage({ commit }, lang) {
      commit('SET_LANGUAGE', lang)
    }
  },
  modules: {
  }
})
